<div class="container" [class.readonly-mode]="!isEditingMode">
  @if (blockedUi) {
  <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
    <i class="pi pi-spin pi-spinner loading" [style.display]="blockedUi ? 'block' : 'none'"></i>
  </div>
  }
  <div class="grid container-header">
    <div class="col-12 md:col-12 lg:col-6 title-position">
      <span class="title" id="titleDetails">{{ 'TRANSLATE.COVERAGE.DETAILS' | translate }}</span>
      <span class="title" id="titleEdit">{{ 'TRANSLATE.EDIT.COVERAGE' | translate }}</span>
      <span class="sub-title" id="subTitle">{{ 'TRANSLATE.REVIEW.UPDATE.COVERAGE.INFORMATION' | translate }}</span>
    </div>
  </div>

  <div class="container-body">
    <div class="product-itens">

      <div class="col-12 md:col-12 lg:col-12 message-edit">

        <div class="col-12 md:col-6 lg:col-4 element-edit space-first">
          <label class="element-edit-label" for="coverageId">{{ 'TRANSLATE.ID.COVERAGE' | translate }} </label>
          <input class="element-edit-input disabled-input" id="coverageId" type="text" [(ngModel)]="coverage.id"
            disabled pInputText>
        </div>

        <div class="col-12 md:col-6 lg:col-4 element-edit space-second">
          <label class="element-edit-label" for="coverageIdName">{{ 'TRANSLATE.COVERAGE.NAME' | translate }}
          </label>
          <input class="element-edit-input disabled-input" id="coverageIdName" [(ngModel)]="coverage.name" type="text"
            minlength="4" maxlength="20" pInputText>

          <div class="message-edit">

            @if (isCoverageNameEmpty()) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORM.COVERAGE.NAME' | translate }}">
            </p-message>
            } @else if (isCoverageNameTooShort()) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.MIN.LENGTH.COVERAGE.NAME' | translate }}">
            </p-message>
            }
          </div>
        </div>

        <div class="col-12 md:col-12 lg:col-4 element-edit space-second">
          <label class="element-edit-label" for="productIdNameSymbol">{{ 'TRANSLATE.ID.PRODUCT.NAME.SYMBOL' | translate
            }} </label>
          <input class="element-edit-input disabled-input" id="productIdNameSymbol" type="text"
            [(ngModel)]="productName" disabled pInputText>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-12 message-edit">

        <div class="col-12 md:col-12 lg:col-12 element-edit space-first">
          <label class="element-edit-label" for="coverageDescription">{{ 'TRANSLATE.COVERAGE.DESCRIPTION' | translate }}
          </label>
          <textarea class="element-edit-input disabled-input" id="coverageDescription"
            [(ngModel)]="coverage.description" type="text" minlength="4" maxlength="100" pInputTextarea></textarea>

          <div class="char-counter">
            {{ coverage.description?.length || 0 }} {{ 'TRANSLATE.MAX.CHARACTERS.100' | translate }}
          </div>

          <div class="message-edit">
            @if (isCoverageDescriptionEmpty()) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORM.DESCRIPTION.COVERAGE' | translate }}">
            </p-message>
            } @else if (isCoverageDescriptionTooShort()) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.MIN.LENGTH.COVERAGE.DESCRIPTION' | translate }}">
            </p-message>
            }
          </div>
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4 element-edit space-first">
        <label class="element-edit-label" for="coverageCountry">{{ 'TRANSLATE.COUNTRY' | translate }} </label>
        <input class="element-edit-input disabled-input" id="coverageCountry" [(ngModel)]="countryNameResult"
          type="text" maxlength="3" disabled pInputText>
      </div>

      <div class="col-12 md:col-4 lg:col-4 element-edit space-second">
        <label class="element-edit-label" for="typeCoverage">{{ 'TRANSLATE.TYPE.COVERAGE' | translate }}
        </label>
        <p-dropdown [options]="listTypeCoverage" id="typeCoverage" [(ngModel)]="selectTypeCoverageGet"
          placeholder="{{ 'TRANSLATE.SELECT' | translate }}" [disabled]="selectDisabled"
          (onChange)="optionCoverageTypeChange($event)" [style]="{'minWidth': '100%'}">
          <ng-template pTemplate="item" let-item>
            {{item?.label | translate}}
          </ng-template>
          <ng-template pTemplate="selectedItem" let-item>
            {{item?.label | translate}}
          </ng-template>
        </p-dropdown>

        @if (isEditingMode && hasAttemptedSave && (selectTypeCoverage === null || selectTypeCoverage === undefined)) {
        <p-message class="client-data-message" severity="error"
          text="{{ 'TRANSLATE.SELECT.TYPE.COVERAGE' | translate }}">
        </p-message>
        }
      </div>

      <div class="col-12 md:col-4 lg:col-4 element-edit space-second">
        <label class="element-edit-label" for="months">{{ 'TRANSLATE.MONTHS' | translate }}
        </label>
        <input class="element-edit-input disabled-input" id="months" [(ngModel)]="coverage.months" type="text"
          maxlength="2" min="0" max="99" (input)="months($event)" pInputText>

        <div class="message-edit">

          @if (isMonthsEmpty()) {
          <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.INFORM.MONTHS' | translate }}">
          </p-message>
		  } @else if (isMonthsZeroOrLess()) {
		  <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.MUST.BE.GREATER.THAN.ZERO' | translate }}">
		  </p-message>
          }
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4 element-edit space-first">
        <label class="element-edit-label" for="distance">{{ 'TRANSLATE.DISTANCE' | translate }}
        </label>
        <input class="element-edit-input disabled-input" id="distance" [(ngModel)]="distanceFormatted" type="text"
          maxlength="7" min="1" max="999999" (input)="formatOdometerNumber($event)" pInputText>

        <div class="message-edit">

          @if (isDistanceEmpty()) {
          <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.INFORM.DISTANCE' | translate }}">
          </p-message>
		  } @else if (isDistanceZeroOrLess()) {
		  <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.MUST.BE.GREATER.THAN.ZERO' | translate }}">
		  </p-message>
          }
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4 element-edit space-second">
        <label class="element-edit-label" for="totalVisits">{{ 'TRANSLATE.TOTAL.VISITS' | translate }}
        </label>
        <input class="element-edit-input disabled-input" id="totalVisits" [(ngModel)]="coverage.visit" type="text"
          maxlength="2" min="1" max="99" (input)="totalVisits($event)" pInputText>

        <div class="message-edit">

          @if (isEditingMode && hasAttemptedSave && (inputTotalVisits === null || inputTotalVisits === undefined)) {
          <p-message class="client-data-message" severity="error"
            text="{{ 'TRANSLATE.INFORM.TOTAL.VISITS' | translate }}">
          </p-message>
          }
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4 element-edit space-second">
        <label class="element-edit-label" for="initialVisit">{{ 'TRANSLATE.INITIAL.VISIT' | translate }}
        </label>
        <input class="element-edit-input disabled-input" id="initialVisit" [(ngModel)]="coverage.startVisit" type="text"
          maxlength="2" min="1" max="99" (input)="initialVisit($event)" pInputText>

        <div class="message-edit">

          @if (isEditingMode && hasAttemptedSave && (inputInitialVisit === null || inputInitialVisit === undefined)) {
          <p-message class="client-data-message" severity="error"
            text="{{ 'TRANSLATE.INFORM.INITIAL.VISIT' | translate }}">
          </p-message>
          }
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4 element-edit space-first">
        <label class="element-edit-label" for="owsCoverage">{{ 'TRANSLATE.OWS.COVERAGE' | translate }}
        </label>
        <input class="element-edit-input disabled-input" id="owsCoverage" [(ngModel)]="coverage.owsCoverage" type="text"
          minlength="4" maxlength="8" pInputText>
        <div class="message-edit">

          @if (isOwsCoverageEmpty()) {
          <p-message class="client-data-message" severity="error"
            text="{{ 'TRANSLATE.INFORM.OWS.COVERAGE' | translate }}">
          </p-message>
          } @else if (isOwsCoverageTooShort()) {
          <p-message class="client-data-message" severity="error"
            text="{{ 'TRANSLATE.MIN.LENGTH.OWS.COVERAGE' | translate }}">
          </p-message>
          }
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4 element-edit space-second">
        <label class="element-edit-label" for="accountCode">{{ 'TRANSLATE.ACCOUNT.ENGLISH' | translate }}</label>
        <input class="element-edit-input disabled-input" maxLength="9" id="accountCode" [(ngModel)]="coverage.account"
          type="text" disabled pInputText>
      </div>

      <div class="col-12 md:col-4 lg:col-4 element-edit space-second">
        <label class="element-edit-label" for="actionCode">{{ 'TRANSLATE.ACTION.ENGLISH' | translate }}</label>
        <input class="element-edit-input disabled-input" id="actionCode" maxLength="1" [(ngModel)]="coverage.actionCode"
          type="text" disabled pInputText>
      </div>

      <div class="col-12 md:col-4 lg:col-4 element-edit space-first">
        <label class="element-edit-label" for="coverageCode">{{ 'TRANSLATE.COVERAGE.ENGLISH' | translate }}</label>
        <input class="element-edit-input disabled-input" id="coverageCode" maxLength="4"
          [(ngModel)]="coverage.coverageCode" type="text" disabled pInputText>
      </div>

      <div class="col-12 md:col-4 lg:col-4 element-edit space-second">
        <label class="element-edit-label" for="insuranceCode">{{ 'TRANSLATE.INSURANCE.ENGLISH' | translate }}</label>
        <input class="element-edit-input disabled-input" id="insuranceCode" maxLength="4"
          [(ngModel)]="coverage.insuranceCode" type="text" disabled pInputText>
        @if (isEditingMode && hasAttemptedSave && (inputInsuranceCode === null || inputInsuranceCode === undefined)) {
        <p-message class="client-data-message" severity="error"
          text="{{ 'TRANSLATE.INFORM.INSURANCE.CODE' | translate }}">
        </p-message>
        }
      </div>

    </div>

    <div class="col-12 md:col-12 lg:col-12 button-position">

      @if (!isEditingMode) {
      <button id="btnReturn" class="undo-action-button app-clean-button" type="button" (click)="buttonReturn()">
        <i class="pi pi-arrow-left" aria-hidden="true"></i>
        <span class="undo-action-button-label">{{ 'TRANSLATE.RETURN' | translate }}</span>
      </button>
      }

      @if (!isEditingMode) {
      <button id="btnEdit" class="action-button app-filter-button" type="button" (click)="buttonEdit()">
        <i class="pi pi-pencil" aria-hidden="true"></i>
        <span class="action-button-label">{{ 'TRANSLATE.EDIT' | translate }}</span>
      </button>
      }

      @if (isEditingMode) {
      <button id="btnCancel" class="undo-action-button app-clean-button" type="button" (click)="buttonCancel()"
        [disabled]="blockedUi">
        <i class="pi pi-times" aria-hidden="true"></i>
        <span class="undo-action-button-label">{{ 'TRANSLATE.CANCEL' | translate }}</span>
      </button>
      }

      @if (isEditingMode) {
      <button id="btnSave" class="action-button app-filter-button" type="submit" (click)="buttonSave()"
        [disabled]="blockedUi">
        @if (!blockedUi) {
        <i class="pi pi-check" aria-hidden="true"></i>
        }
        @if (blockedUi) {
        <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
        }
        <span class="action-button-label">{{ (blockedUi ? 'TRANSLATE.SAVING' : 'TRANSLATE.SAVE') | translate }}</span>
      </button>
      }

    </div>

  </div>
</div>